var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSleepBubble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10811_306280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.66146 15.8327C3.39784 15.8327 3.99479 15.2357 3.99479 14.4993C3.99479 13.7629 3.39784 13.166 2.66146 13.166C1.92508 13.166 1.32812 13.7629 1.32812 14.4993C1.32812 15.2357 1.92508 15.8327 2.66146 15.8327Z",
    stroke: "#680DDB",
    strokeWidth: 1.33333,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.75314 10.0811C5.06406 14.6887 11.5625 15.0392 12.759 11.2037C14.1479 11.2769 15.3307 10.1039 15.3307 8.69682C15.3307 7.19015 14.5974 6.28272 12.759 5.91724C13.4974 2.99341 11.4171 1.16602 8.8122 1.16602C6.86206 1.16602 4.75314 2.05345 4.75314 4.80223C2.4974 4.08985 0.664062 5.35981 0.664062 7.44168C0.664062 9.51562 2.4974 10.6685 4.75314 10.0811Z",
    stroke: "#680DDB",
    strokeWidth: 1.33333,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.32812 5.83203H9.99479V6.2487L7.32812 8.7487V9.16536H9.99479",
    stroke: "#680DDB",
    strokeWidth: 1.33333,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10811_306280"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSleepBubble);
export default __webpack_public_path__ + "static/media/sleep_bubble.918b92c41ef853c40c80fb1c102ce73f.svg";
export { ForwardRef as ReactComponent };